import React from "react";

const ShareTemplate = (props) => {
  return (
    <div id="share">
      <div className="row">
        <div className="col l6 s6 m6">
          <h3>Share Estimate</h3>
          <p>Invite people to estimates:</p>
          <div className="email-wrap">
            <input type="text" placeholder="Email" />
            <button className="invite">Send Invite</button>
          </div>
          <p>shared with:</p>
          <div className="wrap">
            <div className="input-field name">
              <input
                type="text"
                placeholder="Oriana Siska"
                defaultValue="Oriana Siska"
              ></input>
              <ul>
                <li>Option 1</li>
                <li>Option 2</li>
              </ul>
            </div>
            <div className="input-field work">
              <input type="text" placeholder="can edit"></input>
              <i className="material-icons icons">arrow_drop_down</i>
              <ul>
                <li>can write</li>
                <li>can read</li>
              </ul>
            </div>
            <div className="share-link">
              <p>Share Link</p>
              <div className="switch">
                <label>
                  <input type="checkbox" />
                  <span className="lever"></span>
                </label>
              </div>
            </div>
            <div className="link-wrap">
              <p>Anyone with this Link:</p>
              <div className="input-field work">
                <input type="text" placeholder="can edit"></input>
                <i className="material-icons icons">arrow_drop_down</i>
                <ul>
                  <li>can write</li>
                  <li>can read</li>
                </ul>
              </div>
              <div className="copy-link-wrap">
                <input
                  type="text"
                  defaultValue="https://estimatic.com/id/2332"
                ></input>
                <i className="material-icons icons copy-link">filter_none</i>
              </div>
            </div>
          </div>
        </div>
        <div className="col l6 s6 m6">
          <a href="/">
            <i className="material-icons right" onClick={props.click}>
              close
            </i>
          </a>
        </div>
      </div>
    </div>
  );
};

export default ShareTemplate;
